import ListContractTypes from './views/List.vue'
import CreateEdit from './views/CreateEdit.vue'
import Get from './views/Get.vue'

export const ContractTypesRoutes = [
  {
    path: '/contract-types',
    name: 'ListContractTypes',
    component: ListContractTypes,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'contract_type:list'
    }
  },

  {
    path: '/contract-type/',
    name: 'CreateContractType',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'contract_type:create'
    }
  },
  {
    path: '/contract_type/:id',
    name: 'UpdateContractType',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'contract_type:update'
    }
  },
  {
    path: '/contract_type/view/:id',
    name: 'GetContractType',
    component: Get,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'contract_type:get'
    }
  }
]
